import { render, staticRenderFns } from "./OrderDifference.vue?vue&type=template&id=4cde5944"
import script from "./OrderDifference.vue?vue&type=script&lang=js"
export * from "./OrderDifference.vue?vue&type=script&lang=js"
import style0 from "./OrderDifference.vue?vue&type=style&index=0&id=4cde5944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports